//COOKIES
(function() {

	//Modal element
	var wpkCookieConsent = document.getElementById('wpk-cookie-consent');

	if(wpkCookieConsent) {

		//Cookie expire 1 week from now
		var expireDate = new Date();
		expireDate.setDate(expireDate.getDate() + 7);

		//Parent eventListener for performance
		wpkCookieConsent.addEventListener('click', function(event) {

			var target = event.target;
			
			if(target.classList.contains('wpk-cookie-consent-button') ) {
				document.cookie = "wpk_cookie_consent=true; expires=" + expireDate.toGMTString() + '; SameSite=Strict; path=/';
				if(target.id == 'wpk-cookie-allow-button') {
					wpkCookieConsent.classList.add('close');
				}
				
			}

		});
	}
})();